// extracted by mini-css-extract-plugin
export default {"brandContainer":"styleModule_brandContainer__AqVVo","active":"styleModule_active__3D9Kt","image":"styleModule_image__BK4oE","title":"styleModule_title__IUY3e"};